import { Box, Link, Modal, Button, SpaceBetween, Table, Tabs, Container, Header, Form, FormField, Select } from "@cloudscape-design/components";
import { useState } from "react";
import { doGetRequest } from "../api/ApiUtils";
import GraphViewer from "./GraphViewer";

export default (props) => {
    const isLoading = props.isLoading;
    const results = props.items;

    const [modalVisible, setModalVisible] = useState(false);
    const [modalHeader, setModalHeader] = useState("");
    const [topkresults, setTopKResults] = useState([]);
    const [isTopKLoading, setIsTopKLoading] = useState(false);
    const [explainabilityResults, setExplainabilityResults] = useState([]);
    const [isExplainabilityLoading, setIsExplainabilityLoading] = useState(true);
    const [selectedGraphViewStyle, setSelectedGraphViewStyle] = useState({label: "Concentric", value: "concentric"})
    const [graphViewStyle, setGraphViewStyle] = useState("concentric")

    const showModalWindow = (journal) => {
        setModalHeader(journal.title);

        setIsTopKLoading(true);
        setIsExplainabilityLoading(true);

        doGetRequest("get-topk-similarity",`i=${journal.id}&l=20`,false, (data) => {
            setIsTopKLoading(false);
            setTopKResults(data);
        });

        doGetRequest("get-vector-explainability",`q=${journal.id}&l=20`, false, (data) => {
            setIsExplainabilityLoading(false);
            setExplainabilityResults(data.elements);
        });

        setModalVisible(true);
    }

    const displayItemScore = (score) => {
        if (isNaN(score) || score === undefined)
            return "N/A"
        else
            return score;
    }

    const displayExplainabilityLink = (item, forceDisplay) => {
        if ((isNaN(item.score) || item.score === undefined) && !forceDisplay)
            return "N/A"
        else
            return <Link alt="Click to find out how this is related to your query" onFollow={() => showModalWindow(item)}>Show me how &rarr;</Link>
    }

    const displayPadding = (loadingGraphData) => {
        if (loadingGraphData)
            return <><br></br><br></br></>
    }

    return (
        <>
            <Modal
                onDismiss={() => setModalVisible(false)}
                visible={modalVisible}
                size="xlarge"
                footer={
                    <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="primary" onClick={() => setModalVisible(false)}>Close</Button>
                    </SpaceBetween>
                    </Box>
                }
                header={modalHeader}
                >
                <Container>
                    <Tabs
                        tabs={[
                            {
                                label: "TopK Similarity",
                                id: "topk",
                                content: 
                                <Container
                                header={
                                <Header
                                    variant="h2"
                                    description="TopK uses vector similarity based on the embeddings. A lower distance refers to a closer similarity match."
                                >
                                    TopK Similarity
                                </Header>
                                }
                                >
                                    <Table
                                        columnDefinitions={[
                                            {
                                                id: "id",
                                                header: "ID",
                                                isRowHeader: true,
                                                width: "160",
                                                cell: item => item.id
                                            },
                                            {
                                                id: "title",
                                                header: "Journal",
                                                isRowHeader: true,
                                                width: "500",
                                                cell: item => item.title
                                            },
                                            {
                                                id: "abstract",
                                                header: "Abstract",
                                                isRowHeader: true,
                                                width: "780",
                                                cell: item => item.abstract
                                            },
                                            {
                                                id: "distance",
                                                header: "Similarity",
                                                isRowHeader: true,
                                                width: "140",
                                                cell: item => item.distance
                                            },
                                            {
                                                id: "showme",
                                                header: "Explainability",
                                                isRowHeader: true,
                                                width: "150",
                                                cell: item => displayExplainabilityLink(item, true)
                                                
                                            }
                                        ]}
                                        items={topkresults}
                                        loading={isTopKLoading}
                                        loadingText={isTopKLoading?"Loading similar journals": null}
                                        stripedRows={true}
                                        resizableColumns={true}
                                        empty={
                                            <Box
                                                margin={{ vertical: "xs"}}
                                                textAlign="center"
                                                color="inherit">
                                                <SpaceBetween size="m">
                                                    <b>No similar journals found</b>
                                                </SpaceBetween>
                                            </Box>
                                        }>
                                    </Table>
                                </Container>
                            },
                            {
                                label: "Explainability",
                                id: "explain",
                                content: 
                                <Container
                                header={
                                <Header
                                    variant="h2"
                                    description="The graph below shows how the selected journal relates to connected objects within the graph."
                                >
                                    Explainability
                                </Header>
                                }
                                >
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <Form>
                                        <FormField label="Graph view style:">
                                            <div style={{width: '200px'}}>
                                            <Select selectedOption={selectedGraphViewStyle}
                                                    options={[
                                                        {label: "Concentric", value: "concentric"},
                                                        {label: "Hierarchical", value: "hierarchical"},
                                                        {label: "Cose-Bilkent", value: "cose"},
                                                        {label: "Circular", value: "circle"},
                                                    ]}
                                                    onChange={({ detail}) => {
                                                        setGraphViewStyle(detail.selectedOption.value);
                                                        setSelectedGraphViewStyle(detail.selectedOption);
                                                    }}
                                                >
                                                </Select>
                                            </div>
                                        </FormField>
                                        </Form>
                                    </form>
                                    <GraphViewer data={explainabilityResults} isLoading={isExplainabilityLoading} viewStyle={graphViewStyle} allowExploration={false} emptyMessage="No explainability results could be found for the selected journal."></GraphViewer>
                                    {displayPadding(isExplainabilityLoading)}
                                </Container>
                            }
                        ]}
                    >
                    </Tabs>
                </Container>
            </Modal>
            
            <Table
                columnDefinitions={[
                    {
                        id: "id",
                        header: "ID",
                        isRowHeader: true,
                        width: "160",
                        cell: item => item.id
                    },
                    {
                        id: "title",
                        header: "Journal",
                        isRowHeader: true,
                        width: "500",
                        cell: item => item.title
                    },
                    {
                        id: "abstract",
                        header: "Abstract",
                        isRowHeader: true,
                        width: "780",
                        cell: item => item.abstract
                    },
                    {
                        id: "score",
                        header: "Similarity",
                        isRowHeader: true,
                        width: "140",
                        cell: item => displayItemScore(item.score)
                    },
                    {
                        id: "showme",
                        header: "Explainability",
                        isRowHeader: true,
                        width: "150",
                        cell: item => displayExplainabilityLink(item)
                        
                    }
                ]}
                //items={results.slice(((currentPageIndex-1)*PAGE_SIZE),(PAGE_SIZE*(currentPageIndex-1))+(PAGE_SIZE-1))}
                items={results}
                loading={isLoading}
                loadingText={isLoading?"Loading journals": null}
                stripedRows={true}
                resizableColumns={true}
            /*  pagination={
                    <Pagination 
                        currentPageIndex={currentPageIndex} 
                        pagesCount={Math.ceil(results.length / PAGE_SIZE)}
                        onChange={({detail}) => {setCurrentPageIndex(detail.currentPageIndex)}}></Pagination>
                } */
                empty={
                    <Box
                        margin={{ vertical: "xs"}}
                        textAlign="center"
                        color="inherit">
                        <SpaceBetween size="m">
                            <b>No journals found</b>
                        </SpaceBetween>
                    </Box>
                }>
            </Table>
        </>
    )
    
}